export function buildPath(root: string, list) {
    let path = root + '?'
    for (const element of list) {
        if (element[1]) {
            path += element[0] + '=' + element[1] + '&'
        }
    }
    return path.slice(0, -1)
}
